/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {
    Page,
    Preload,
    WKError
} from '../../components'
import { judgeAPPVersion, isLZWKAPP } from '../../utils'
import {NoneItem} from '../../components/details'
import {
    MainTopBar,
    MainDatacenter,
    MainContent,
    MainSaleList,
    MainManageList,
    LiveroomCell,
    MainEntry,
} from '../../components/liveroomLecturer'
import '../../css/page/LiveroomLecturerPage.css'
import errorImg from '../../images/no-source.png'

class MainPage extends React.Component {

    componentDidMount() {
        let id = this.props.routeParams.liveroom_id;

        document.title = '直播间操作面板';

        this.props.dispatch({
            type: 'LIVEROOM_ID_SAVE',
            payload: id
        });

        axios.get(`/api/liveroom/${id}/dashboard`)
            .then((res) => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'LIVEROOMSETTINGINIT',
                        payload: res.data.data
                    })
                }
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '网络连接出问题了。',
                        img: errorImg,
                        href: '/?st=liveroom_setting_main_404',
                        btn: '去首页看看'
                    }
                });
            }else if (error.response && error.response.status === 403){
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '你没有查看此内容的权限!',
                        img: errorImg,
                        href: '/?st=liveroom_setting_main_403',
                        btn: '去首页看看'
                    }
                });
            }
        });
    }

    renderCellBody() {
        return(
            <div className="mainpage-datacenter-cell">
                使用教程
            </div>
        )
    }

    render() {
        const {error} = this.props;
        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <NoneItem
                        img="https://static-1253442168.image.myqcloud.com/picture/5915685_afa47c9f8b61cd74f79b3dcf52a1be39.jpg"
                        text={error.tips}
                        btnText="回首页看看"
                        btnMethod={() => window.location="/"}
                    />
                </div>
            )
        }

        const {liveroomSetting} = this.props;

        if (!liveroomSetting.liveroomSettingMainInit){
            return <Preload/>
        }

        return (
            <Page>
                <div className="liveroom-setting-main-page">

                    <MainEntry liveroomId={liveroomSetting.liveroom_id}/>

                    <MainTopBar />

                    <MainDatacenter />

                    <MainContent/>

                    <MainSaleList/>

                    <MainManageList/>

                    {/*<LiveroomCell body={this.renderCellBody()}/>*/}

                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting,
    error: state.error,
}))(MainPage)




// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/MainPage.js